<template>
    <b-modal :open="open" @close="onClose" :title="$t('text.confirm')">
        <template v-slot:default>
            <p>{{ $t("text.ignore_action") }}</p>
        </template>
        <template v-slot:modal-footer>
            <button @click="onConfirm" class="primary-btn">
                {{ $t("text.yes") }}
            </button>
        </template>
    </b-modal>
</template>

<script lang="ts">
import BModal from "../../components/Modal/BModal.vue";
import {computed, ref} from "vue";
import { useI18n } from "vue-i18n";
import {useStore} from 'vuex'
import {useToast} from "vue-toastification";



import userApi from "../../api/user";

export default {
    components: { BModal },
    setup(props, { emit }) {
        const store = useStore();
        const open = ref(false);
        const { t } = useI18n({ useScope: "global" });
        const toast = useToast();
        const userId = ref(null);



        const onClose = async function () {
            open.value = false;
        };

        const onConfirm = async function () {
            open.value = false;
            try {
                await userApi.ignoreUpdatePassword(userId.value);
            } catch (e) {
                toast.error(t("code_errors." + e.message));
            }
        };

        const onOpen = function (id) {
            open.value = true;
            userId.value = id;
        };

        return {
            open,
            onClose,
            onConfirm,
            onOpen,
        };
    },
};
</script>